module.exports = __webpack_public_path__ + "img/round-bg-opacity.9bfba775.png";